import { InjectionToken } from '@angular/core';
import { Subject } from 'rxjs';
import type { MessagesService } from '../messages/messages.service';
import type { ModalNotificationLauncher } from '../modal-notification/modal-notification.domain';

export const ROUTER: InjectionToken<AppRouter> = new InjectionToken<AppRouter>('appRouter');

export type UrlMatcherFn = (path: string, search?: unknown, hash?: string, options?: unknown) => unknown;

export interface AppRouter {
  registerFutureStates(states: unknown): void;

  listenForUrlChange(): void;

  disableListenForUrlChange(): void;

  listenForCriticalMessages?(criticalMessagesSubject: Subject<boolean>,
                            messagesService: MessagesService,
                            modalNotificationLauncherService: ModalNotificationLauncher,
                            onEvent: 'onSuccess' | 'onExit',
                            withSetup: boolean): void;

  handleFocusOnPageTransition(): void;

  registerNotificationTrigger?(modalNotifyLaunchService: ModalNotificationLauncher): void;

  registerPageInitialLoad?(onLoad: () => void): void;

  registerPagesLoad?(onLoad: () => void): void;

  registerModalClose?(name: string, onClose: () => void): void;

  generateUrl(stateOrName: unknown, params?: unknown, options?: unknown): string;

  setInitialState(url: string): void;

  setFallbackState(url: string): void;

  getStateFromUrl<T>(url: string): T;

  getUrlMatcherFn(transition: unknown): UrlMatcherFn;

  navigate(stateName: string, params?: Record<string, unknown>): Promise<boolean>;
}

/* class decorator */
export function staticImplements<T>() {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/no-unused-expressions,@typescript-eslint/explicit-module-boundary-types
  return <U extends T>(constructor: U) => { constructor };
}

export interface RouterConfigService<T, R> {
  new(): T;

  configure(router: R): void;

  configureTrace(router: R): void;

  configureHelp(router: R): void;

  configureSerializers(router: R): void;

  configureBaseRoutes(router: R): void;

  configureErrorHandler(router: R): void;

  configureTransitionHooks(router: R): void;
}
